import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
const axios = require('axios');
const Cookies = require('js-cookie');

const vuexPersist = new VuexPersist({
    key: 'exam-digitizer',
    storage: sessionStorage,
});

Vue.use(Vuex);
// Vue.config.devtools = true 
export default new Vuex.Store({
  plugins: [vuexPersist.plugin],
  state: {
    user: {
      loggedIn: false,
      name: "",
      ccid: "",
      expires: false,
    },
    examId: null,
    exam: {
      name: "",
      questions: [],
    },
    examTokens: null,
  },
  getters: {
    auth(state) {
      return state.user;
    },
    getExamTokens: state => state.examTokens,
    getExam: state => state.exam,
  },
  mutations: {
    setUser(state, data) {
      state.user = data;
    },
    setExamId(state, data) {
      state.examId = data;
    },
    setExam(state, data) {
      state.exam = data;
    },
    setExamTokens(state, data) {
      state.examTokens = data;
    },
  },
  actions: {
    async login() {
      let config = await axios.get("/config");
      window.location.href = `${config.data.cognito_url}/oauth2/authorize?redirect_uri=${config.data.callback_url}/&response_type=token&client_id=${config.data.client_id}&state=STATE&scope=profile%20email%20openid`;
    },
    async logout(context) {
      let config = await axios.get("/config");

      Cookies.remove("access_token");
      Cookies.remove("id_token");
      context.commit("setUser", {
        loggedIn: false,
        name: "",
        ccid: "",
        expires: false,
      });

      // Logout from cognito and redirect to logout landing page
      window.location.href = `${config.data.cognito_url}/logout?client_id=${config.data.client_id}&logout_uri=${config.data.logout_url}`;
    },
    async convertExam(context, payload) {
      const { exam } = payload;

      const API_CLIENT = axios.create({
        baseURL: "/api/",
      });

      try {
        const idToken = Cookies.get('id_token');
        let convertedfile = await API_CLIENT.post(
          "docx2textblobs",
          { b64file: exam },
          {
            "Content-Type": "application/json",
            headers: {
              Authorization: idToken,
            },
          }
        );
        console.log(convertedfile);
        const { uuid, tokens } = convertedfile.data;

        let tokensArray = [];
        for (let i = 0; i < tokens.length; i++) {
          tokensArray.push({
            index: i,
            value: tokens[i],
            active: true,
            removed: false,
          });
        }
        context.commit("setExamTokens", tokensArray);
        context.commit("setExamId", uuid);
      } catch (error) {
        console.log(error);
      }
    },
    setUser(context, data) {
      context.commit("setUser", data);
    },
  },
});